import React from 'react';
import { useNavigate } from 'react-router-dom';

import { SvgCardType } from '../../components/svg-card/svg-card-types';
import { urler } from '../../router/router-urler';
import { RadioAlternativ } from '../../sporsmalsflyt/reducer/sporsmalsflyt-types';
import { Skademeldingstype } from '../../types/generated-types';
import { skadeUrlFromSkadetype } from '../../urler';
import { KategoriSvarId } from '../sporsmal-og-svar';
import { Dyr, GruppeLandingssideDyr } from './gruppe-landingsside-dyr';

const alternativer: RadioAlternativ[] = [
    {
        id: KategoriSvarId.DyrKatt,
        tekst: 'Behandlingsutgifter',
        undertekst: 'Erstatning av utgifter i forbindelse med skade, sykdom og rehabilitering.',
    },
    {
        id: KategoriSvarId.DyrAnnet,
        tekst: 'Annet',
    },
];

export const Katt = () => {
    const navigate = useNavigate();

    const onNext = (svarId: string) => {
        if (svarId === KategoriSvarId.DyrKatt) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.Katt));
        } else if (svarId === KategoriSvarId.DyrAnnet) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.Dyr));
        }
    };

    const goback = () => navigate(urler().dyrUrl);

    return (
        <GruppeLandingssideDyr
            title="Katt"
            radioButtonsLabel="Hva trenger du hjelp til?"
            alternativer={alternativer}
            dyr={Dyr.Katt}
            onNext={onNext}
            navigateToParent={goback}
            svgCardType={SvgCardType.DyrKatt}
        />
    );
};
